import React from "react";
import "./MachineDescription.css";

function clean(value) {
  if (value === null || value === undefined) return "";

  const text = String(value).trim();

  return ["", "null", "undefined", "n/a", "-"].includes(text.toLowerCase())
    ? ""
    : text;
}

export default function MachineDescription({ product }) {
  if (!product) return null;

  const name = clean(product.machine_name) || "Embroidery machine";
  const brand = clean(product.brand);
  const model = clean(product.model);
  const age = clean(product.machine_old);
  const heads = clean(product.NoOfHeads);
  const needles = clean(product.NoOfNeedls);
  const speed = clean(product.Maxsewingspeed);
  const area = clean(product.Area);
  const computer = clean(product.Comtype);
  const motor = clean(product.motor);
  const leftHead = clean(product.left_head_type);
  const rightHead = clean(product.right_head_type);
  const description = clean(product.description);
  const place = [
    clean(product.city),
    clean(product.state),
  ].filter(Boolean).join(", ");
  const rawPrice = clean(product.price);
  const price = Number(rawPrice.replace(/,/g, ""));

  const formattedPrice =
    rawPrice && Number.isFinite(price) && price > 0
      ? `₹${price.toLocaleString("en-IN")}`
      : "";

  const introduction = [
    `${name} is listed${place ? ` in ${place}` : ""}.`,
    brand ? `The listed brand is ${brand}.` : "",
    model ? `The model is ${model}.` : "",
    formattedPrice ? `The seller’s asking price is ${formattedPrice}.` : "",
    age ? `The machine age is listed as ${age}.` : "",
  ].filter(Boolean).join(" ");

  const specifications = [
    heads ? `Number of heads: ${heads}.` : "",
    needles ? `Listed needle count: ${needles}.` : "",
    speed ? `Maximum sewing speed: ${speed} RPM.` : "",
    area ? `Listed machine area: ${area}.` : "",
    leftHead ? `Left-side head type: ${leftHead}.` : "",
    rightHead ? `Right-side head type: ${rightHead}.` : "",
    computer ? `Computer type: ${computer}.` : "",
    motor ? `Motor: ${motor}.` : "",
  ].filter(Boolean).join(" ");

  return (
    <section
      className="machine-description"
      aria-label={`About ${name}`}
    >
      <span className="machine-description__label">
        MACHINE OVERVIEW
      </span>

      <h2>About {name}</h2>

      <p>{introduction}</p>

      {specifications && (
        <>
          <h3>Listed specifications</h3>
          <p>{specifications}</p>
        </>
      )}

      {description && (
        <>
          <h3>Seller’s description</h3>
          <p className="machine-description__seller">
            {description}
          </p>
        </>
      )}

      <h3>What to check before buying</h3>

      <p>
        Ask the seller for a live stitching demonstration and inspect
        stitch quality, thread trimming, head operation, and the control
        panel. Confirm the working area, power requirements, maintenance
        history, included accessories, and availability of spare parts.
        Discuss transport, installation, and the final price before
        making a purchase.
      </p>

      <p className="machine-description__note">
        Specifications and price are provided in the listing.
        Confirm the machine’s current condition and availability
        directly with the seller.
      </p>
    </section>
  );
}